import {getSavedState, saveState} from "@utils/util";
export const state = {

    selectedUser: null,
    selectedUserInfo: {},
    lastViewed: getSavedState('chat.lastViewed'),

};

export const getters = {

};


export const mutations = {

    SET_SELECTED_USER(state, val){
        state.selectedUser = val;
    },
    SET_SELECTED_USER_INFO(state, val){
        state.selectedUserInfo = val;
    },
    SET_LAST_VIEWED(state, val){
        state.lastViewed = val;
        saveState('chat.lastViewed', val);
    },

};

export const actions = {


    setLastViewed({commit}, val){
        commit('SET_LAST_VIEWED', val);
    },

    setSelectedUser({commit}, val){
        commit('SET_SELECTED_USER', val);
    },

    setSelectedUserInfo({commit}, val){
        commit('SET_SELECTED_USER_INFO', val);
    },

    reset({state, commit}){
        commit('SET_LAST_VIEWED', null);
        commit('SET_SELECTED_USER', null);
        commit('SET_SELECTED_USER_INFO', null);

    }

}
